import { SagaIterator } from "redux-saga";
import { CreateReportListRequest, DownloadReport, ReportCommonReduxTypes } from "./types";
import { fork, call, put, takeEvery, all } from "redux-saga/effects";
import { downloadReportApi, listReportApi } from "./api";

function* listReports({ payload }: CreateReportListRequest): SagaIterator {
  try {
    const response = yield call(listReportApi, payload);
    yield put({
      type: ReportCommonReduxTypes.LIST_REPORT_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: ReportCommonReduxTypes.LIST_REPORT_ERROR,
      payload: { error: error }
    });
  }
}

function* downloadReport({ payload }: DownloadReport): SagaIterator {
  try {
    const response = yield call(downloadReportApi, payload);
    const file = payload.location.split("/")
    const responseData = {
      fileBlob: response.data,
      fileName: file[file.length - 1],
    }
    yield put({
      type: ReportCommonReduxTypes.DOWNLOAD_REPORT_SUCCESS,
      payload: { data: responseData }
    });
  } catch (error: any) {
    yield put({
      type: ReportCommonReduxTypes.DOWNLOAD_REPORT_ERROR,
      payload: { error: error }
    });
  }
}

export function* watchListReport() {
  yield takeEvery(ReportCommonReduxTypes.LIST_REPORT, listReports);
}

export function* watchDownloadReport() {
  yield takeEvery(ReportCommonReduxTypes.DOWNLOAD_REPORT, downloadReport);
}

function* reportSaga() {
  yield all([fork(watchListReport),fork(watchDownloadReport)]);
}

export default reportSaga;
